var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gst-manage-booking-cancel"},[_vm._v("Cancel")])}
var staticRenderFns = []

export { render, staticRenderFns }